export enum RoleType {
  SuperAdmin = 1,
  System,
  EHR,
  External,
  Admin,
  Specialist,
  Nurse,
  Doctor,
  Psychologist,
  Nutritionist,
  CustomerSupport,
  TechSupport,
  Patient,
  Caregiver,
  Others,
  GuestPatient = 999,
  GuestCareGiver
}

export enum VcRoleType {
  Specialist = 1,
  Nurse,
  Doctor,
  Psychologist,
  Nutritionist,
  Patient = 9
}
